import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { type ReactElement } from 'react';
import config from 'shared/config';
import { GTM_ID } from 'shared/googleTagManager';
export const GoogleTagManagerScript = () => {
  const $ = _c(2);
  if (config("APP_ENV") !== "production") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="google-tag-manager" strategy="afterInteractive">{`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `}</Script>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const GoogleTagManagerNoscript = () => {
  const $ = _c(2);
  if (config("APP_ENV") !== "production") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <noscript dangerouslySetInnerHTML={{
      __html: `
            <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `
    }} />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};